import { useState, useEffect } from 'react';

export default function DocsTOC({ content }) {
  const [activeId, setActiveId] = useState('');

  const headings = (content || []).filter(block => block.type === 'heading' && block.id);

  useEffect(() => {
    if (headings.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter(e => e.isIntersecting);
        if (visible.length > 0) {
          setActiveId(visible[0].target.id);
        }
      },
      { rootMargin: '-80px 0px -60% 0px', threshold: 0 }
    );

    headings.forEach(h => {
      const el = document.getElementById(h.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [headings]);

  if (headings.length === 0) return null;

  return (
    <nav aria-label="Table of contents" className="space-y-0.5 border-l border-border pl-4" data-testid="docs-toc">
      <p className="text-[10px] font-mono uppercase tracking-[0.12em] text-muted-foreground/70 font-bold mb-3">On this page</p>
      {headings.map(h => (
        <a
          key={h.id}
          href={`#${h.id}`}
          className={`block text-[12px] py-1.5 leading-snug transition-colors ${activeId === h.id ? 'text-foreground font-semibold' : 'text-muted-foreground hover:text-foreground'} ${h.level === 3 ? 'pl-3' : ''}`}
          data-testid={`toc-${h.id}`}
        >
          {h.text}
        </a>
      ))}
    </nav>
  );
}
